import { ProFormTimePicker } from '@ant-design/pro-components'
import type { Dayjs } from 'dayjs'
import { EditableLabel } from '../components/EditableLabel'
import { EditableShell } from '../components/EditableShell'
import { useFieldContext } from '../createAppFormHook'
import { useEditableFieldMode } from '../hooks/useEditableFieldMode'
import { useMergedFieldProps } from '../utils/mergeFieldProps'

export interface TimeRangePickerFieldProps extends React.ComponentProps<typeof ProFormTimePicker.RangePicker> {
  label?: string
}

export function TimeRangePickerField(props: TimeRangePickerFieldProps) {
  const fieldCtx = useFieldContext<[Dayjs, Dayjs] | undefined>()
  const { formItemProps, fieldProps, proFieldProps, className, ...rest } = props

  const editable = useEditableFieldMode<[Dayjs, Dayjs] | undefined>()

  const merged = useMergedFieldProps({
    fieldCtx,
    editable,
    props,
    fieldDefaults: {
      fieldProps: {
        onChange: (value: [Dayjs, Dayjs] | null) => fieldCtx.handleChange(value ?? undefined),
      },
    },
  })

  return (
    <EditableShell
      mode={editable.mode}
      enterEdit={editable.enterEdit}
      exitRead={editable.exitRead}
      className={className}
    >
      <ProFormTimePicker.RangePicker
        label={
          <EditableLabel
            mode={editable.mode}
            enterEdit={editable.enterEdit}
            exitRead={editable.exitRead}
            onUndo={editable.undoAndExit}
            canUndo={editable.canUndo}
          >
            {rest.label}
          </EditableLabel>
        }
        proFieldProps={merged.proFieldProps}
        formItemProps={merged.formItemProps}
        fieldProps={merged.fieldProps}
      />
    </EditableShell>
  )
}
